import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconSocialInstagram extends MeasurIcon<
  SVGProps<SVGSVGElement>
> {
  render() {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...this.props}
      >
        <path
          d="M14.1667 1.66666H5.83334C3.53215 1.66666 1.66667 3.53214 1.66667 5.83333V14.1667C1.66667 16.4679 3.53215 18.3333 5.83334 18.3333H14.1667C16.4679 18.3333 18.3333 16.4679 18.3333 14.1667V5.83333C18.3333 3.53214 16.4679 1.66666 14.1667 1.66666Z"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 9.475C13.4362 10.1685 13.3177 10.8768 12.9948 11.4992C12.6719 12.1215 12.161 12.6262 11.5347 12.9414C10.9084 13.2566 10.1987 13.3663 9.50648 13.2549C8.81427 13.1436 8.1748 12.8167 7.67903 12.321C7.18326 11.8252 6.85644 11.1857 6.74505 10.4935C6.63366 9.80129 6.74338 9.09158 7.0586 8.46531C7.37382 7.83904 7.87848 7.32812 8.50082 7.0052C9.12315 6.68228 9.83146 6.56382 10.525 6.66667C11.2324 6.77157 11.8874 7.10122 12.3931 7.60692C12.8988 8.11262 13.2284 8.76756 13.3333 9.475Z"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5833 5.41666H14.5917"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}
